import { Link } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';

const updates = [
    {
        date: 'Hoje',
        version: 'Versão Vite',
        title: 'Migração para Vite',
        items: [
            'Performance aprimorada com Vite',
            'Navegação entre capítulos otimizada',
            'XP ganho ao marcar capítulo como lido corrigido',
            'Interface mobile mais fluida',
            'Melhorias no sistema de cache e offline',
        ]
    }
];

export default function AtualizacoesPage() {
    return (
        <main className="min-h-screen bg-black text-white">
            <div className="max-w-4xl mx-auto px-4 pt-28 pb-20">
                <div className="mb-12">
                    <Link to="/" className="inline-flex items-center gap-2 text-white/40 hover:text-white transition-all mb-8 group">
                        <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1" /> Voltar
                    </Link>
                    <h1 className="text-4xl font-black text-orange-500 mb-2 italic uppercase">Atualizações</h1>
                    <p className="text-white/40 uppercase font-bold tracking-widest text-xs">Histórico de melhorias e correções</p>
                </div>

                <div className="space-y-6">
                    {updates.map((update, index) => (
                        <div key={index} className="bg-neutral-900 border border-white/5 rounded-2xl p-8 hover:border-orange-500/20 transition-all">
                            <div className="flex items-center gap-4 mb-6">
                                <span className="text-xs font-black text-orange-400 bg-orange-500/10 px-3 py-1 rounded-lg uppercase italic">{update.version}</span>
                                <span className="text-xs font-bold text-white/20 uppercase tracking-widest">{update.date}</span>
                            </div>
                            <h2 className="text-xl font-bold text-white mb-6 uppercase italic">{update.title}</h2>
                            <ul className="space-y-4">
                                {update.items.map((item, itemIndex) => (
                                    <li key={itemIndex} className="flex items-start gap-3 text-white/70">
                                        <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                                        <span className="font-medium text-sm">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
}
